<template>
  <div class="relative overflow-hidden rounded-full">
    <label
      class="bg-background-fg/3 border-r-1 border-background-fg/8 absolute inset-y-0 left-0 flex w-20 items-center justify-center"
      for="search-input"
    >
      Search
    </label>
    <input
      id="search-input"
      :value="modelValue"
      type="search"
      enterkeyhint="search"
      :class="[
        'border-background-fg/8 border-1 bg-background block w-full rounded-full pl-24 text-sm font-semibold focus:outline-none',
        'focus:border-primary focus:ring-primary',
      ]"
      @input="onInput"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string | undefined
}>()
const emit = defineEmits<{
  (
    event: "update:modelValue",
    value: typeof props.modelValue
  ): void
}>()

const onInput = (event: Event) => {
  const value_ = (event.target as HTMLInputElement)?.value
  emit("update:modelValue", value_)
}
</script>
